import { render, staticRenderFns } from "./ProductListPagination.vue?vue&type=template&id=71f47305&scoped=true&"
import script from "./ProductListPagination.vue?vue&type=script&lang=js&"
export * from "./ProductListPagination.vue?vue&type=script&lang=js&"
import style0 from "./ProductListPagination.vue?vue&type=style&index=0&id=71f47305&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f47305",
  null
  
)

export default component.exports